//******************************//
// VC Predictive Search (DH - Created: 2026-10-14 / Modified: *)
//
// Opens the modal in snippets/vc-search-modal.liquid and fills it from
// Shopify's /search/suggest endpoint, which renders
// sections/vc-predictive-search.liquid and returns the HTML.
//
// No jQuery: the theme loads it with defer, and search shouldn't wait on it.
//******************************//
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;

  function init() {
    var dialog = document.getElementById('vc-search');
    if (!dialog || typeof dialog.showModal !== 'function') return; // Falls back to the /search link

    var input = dialog.querySelector('.vc-search__input');
    var results = dialog.querySelector('.vc-search__results');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var cache = {};
    var timer = null;
    var controller = null;
    var activeIndex = -1;
    var lastTrigger = null;

    //******************************//
    function open(trigger) {
      lastTrigger = trigger || null;
      dialog.showModal();
      document.documentElement.classList.add('vc-search-open');
      input.focus();
      input.select();
    }

    function close() {
      if (dialog.open) dialog.close();
      closed();
    }

    // Runs from close() and from the dialog's own close event (Esc), so it has to be safe twice
    function closed() {
      document.documentElement.classList.remove('vc-search-open');
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    dialog.addEventListener('close', closed);

    //******************************//
    /* -- Triggers -- */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-vc-search-open]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }
      if (event.target.closest('[data-vc-search-close]')) {
        close();
      }
    });

    /* -- Backdrop: the panel fills the dialog, so a click on the dialog itself is outside it -- */
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    //******************************//
    /* -- Fetch -- */
    function clear() {
      results.innerHTML = '';
      setActive(-1);
      input.setAttribute('aria-expanded', 'false');
      dialog.classList.remove('_has_results', '_loading');
    }

    function render(html) {
      results.innerHTML = html;
      setActive(-1);
      var hasBody = !!results.querySelector('.vc-search__body');
      input.setAttribute('aria-expanded', hasBody ? 'true' : 'false');
      dialog.classList.toggle('_has_results', hasBody);
    }

    function search(term) {
      if (cache[term] !== undefined) {
        render(cache[term]);
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();
      dialog.classList.add('_loading');

      var params = new URLSearchParams();
      params.set('q', term);
      params.set('section_id', dialog.dataset.sectionId);
      params.set('resources[type]', dialog.dataset.resources || 'product');
      params.set('resources[limit]', dialog.dataset.limit || '8');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');

      fetch(root + 'search/suggest?' + params.toString(), { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search ' + response.status);
          return response.text();
        })
        .then(function (text) {
          // The response is the whole section wrapper; keep only what's inside it
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('.shopify-section');
          var html = section ? section.innerHTML : '';
          cache[term] = html;
          dialog.classList.remove('_loading');
          if (input.value.trim() === term) render(html);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          dialog.classList.remove('_loading');
          clear();
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < MIN_CHARS) {
        if (controller) controller.abort();
        clear();
        return;
      }
      timer = setTimeout(function () { search(term); }, DEBOUNCE_MS);
    });

    //******************************//
    /* -- Keyboard: arrows move through results, Enter opens one, otherwise the form submits to /search -- */
    function options() {
      return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    }

    function setActive(index) {
      var all = options();
      all.forEach(function (option, i) {
        option.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      activeIndex = index;
      if (index >= 0 && all[index]) {
        input.setAttribute('aria-activedescendant', all[index].id);
        all[index].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    input.addEventListener('keydown', function (event) {
      var all = options();
      if (event.key === 'ArrowDown' && all.length) {
        event.preventDefault();
        setActive(activeIndex + 1 >= all.length ? 0 : activeIndex + 1);
      } else if (event.key === 'ArrowUp' && all.length) {
        event.preventDefault();
        setActive(activeIndex - 1 < 0 ? all.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0 && all[activeIndex]) {
        var link = all[activeIndex].querySelector('a');
        if (link) {
          event.preventDefault();
          window.location.href = link.href;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
